// IE 2026 10 23 / ODOO-348708 (заказ Игоря: окно «Вигляд doc.fields» — колонка «Колонка» не совпадает с номерами в шапке грида):
// чистая логика (без Vue и DOM) двух вещей окна настроек колонок грида (AttrGrid, isColumnsConfig):
//  1. colnum_number — номер колонки грида для строки дерева атрибутов; он обязан совпадать с номером в шапке самого грида (e_col + 1);
//  2. colnum_attrsIndex — индекс строки дерева для binding колонки (кнопка ⚙ ставит на неё окно).
// Вложенный грид (attr_type AttrGrid: conditional_format, WHERE, fields…) в шапке родителя — ОДНА колонка (scan_column_fromAttrs не раскрывает его
// детей), поэтому его дети (и их потомки) номера не получают и счётчик не двигают.
// Проверка: node --test 'tests/unit/fieldsColnum*.test.mjs'

// атрибут — вложенный грид: колонка родителя, дети в колонки родителя не попадают
export function colnum_isNestedGrid(attr) {
    return !!attr && attr.attr_type === 'AttrGrid'
}

// rows — строки дерева окна ({ level, hasChildren, dataItem }), eRow — индекс строки, isEnabled(dataItem) — строка участвует в колонках грида
// (use !== false и не служебная). Возвращает 1-based номер колонки или null (строка номера не имеет).
export function colnum_number(rows, eRow, isEnabled) {
    const seenBindings = new Set()
    const nested = (r) => colnum_isNestedGrid(r.dataItem)
    // узел с детьми, который в колонках — один лист (вложенный грид), считаем как лист
    const isLeaf = (r) => !r.hasChildren || nested(r)

    // сколько колонок вносит строка idx и её включённые потомки; повтор binding — 0
    const countLeafs = (idx) => {
        const r = rows[idx]
        if (!r || !isEnabled(r.dataItem)) return 0
        const binding = r.dataItem?.binding
        if (isLeaf(r)) {
            if (binding) {
                if (seenBindings.has(binding)) return 0
                seenBindings.add(binding)
            }
            return 1
        }
        let arrowLeaf = 0
        if (binding && !seenBindings.has(binding)) {
            seenBindings.add(binding)
            arrowLeaf = 1
        }
        let leafs = 0
        const lev = r.level
        for (let j = idx + 1; j < rows.length && rows[j].level > lev; j++) {
            if (rows[j].level === lev + 1) leafs += countLeafs(j)
        }
        return (arrowLeaf && leafs > 0 ? 1 : 0) + leafs
    }

    let counter = 0
    const walk = (startI, level) => {
        for (let i = startI; i < rows.length;) {
            const r = rows[i]
            if (r.level < level) break
            if (r.level !== level) { i++; continue }
            let end = i + 1
            while (end < rows.length && rows[end].level > level) end++
            if (i === eRow) {
                if (!isEnabled(r.dataItem)) return null
                if (r.hasChildren && !nested(r) && !r.dataItem?.binding) return null
                const b = r.dataItem?.binding
                if (b && seenBindings.has(b)) return null
                return counter + 1
            }
            if (eRow > i && eRow < end) {
                if (!isEnabled(r.dataItem)) return null
                if (nested(r)) return null   // ребёнок вложенного грида — не колонка родителя
                const b = r.dataItem?.binding
                if (b && !seenBindings.has(b)) {
                    seenBindings.add(b)
                    counter++
                }
                return walk(i + 1, level + 1)
            }
            if (isEnabled(r.dataItem)) counter += countLeafs(i)
            i = end
        }
        return null
    }
    return walk(0, 0)
}

// attrs — дерево атрибутов грида (attr.attrs); индекс строки дерева окна (DFS-счёт: каждый атрибут +1, вкладки и дети вложенных гридов тоже).
// Одинаковый binding бывает и у ребёнка вложенного грида (conditional_format.template), и у колонки грида (template) — берём сначала колонку
// грида, и только если её нет — ребёнка вложенного грида (первого по порядку). Не найдено — -1.
export function colnum_attrsIndex(attrs, binding) {
    if (!binding) return -1
    let index = 0
    let own = -1
    let any = -1
    const find = (list, inNested) => {
        for (const attr of list || []) {
            if (attr && attr.binding === binding) {
                if (any < 0) any = index
                if (!inNested) { own = index; return true }
            }
            index++
            if (attr?.attrs?.length && find(attr.attrs, inNested || colnum_isNestedGrid(attr))) return true
        }
        return false
    }
    find(attrs, false)
    return own >= 0 ? own : any
}
